import PropTypes from 'prop-types';
import _ from 'lodash';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import {AgyleNamedIcon} from '../../../../../components/icons/agyle';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.mode === 'light' ? '#EFF1F3' : '#313233',
        minHeight: 105,
        width: '100%',
        height: '100%',
        borderRadius: 10,
        display: "flex",
        padding: "12px",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "16px",
        flex: "1 0 0",
        border: '1px solid transparent',

        "&.noGap" : {
            gap: 0
        }
    },
    title: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexBasis: '100%',
        minWidth: '100%',
        flexGrow: 1,
    },
    content: {
        display: "flex",
        flexBasis: '100%',
        minWidth: '100%',
        alignItems: "center",
        gap: 9,
        "& svg": {
            width: 36,
            height: 36,
        },
        "&.red": {
            "& svg": {
                color: "#E25B61",
            },
        },
        "&.yellow": {
            "& svg": {
                color: "#F7A202",
            },
        },
        "&.green": {
            "& svg": {
                color: "#4EAC6F",
            },
        },
    }
}));

const ExtendedComponentWidget = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
      <div
        className={clsx(classes.root, props?.noGap && 'noGap')}
        onClick={props.onRootClick}
        style={{ borderColor: props.borderColor || "transparent", cursor: props.onRootClick ? "pointer" : "default"}}
      >
        <div className={clsx(classes.title, props.titleStyle)}>
            <Typography
              variant="subtitle1"
              style={{
                color: props.borderColor || "",
                display: "inline-block",
              }}
            >
              {t(props.title)}
            </Typography>

          {props?.secondaryTitle && props.secondaryTitle}
        </div>

        <div className={clsx(classes.content, props.iconColor, props.contentStyle)}>
          {props.renderContent ? (
            props.renderContent()
          ) : (
            <>
              {!props?.noIcon && (
                <AgyleNamedIcon
                  name={props.iconName ? props.iconName : "bed"}
                  style={{
                    color: props.iconColor ? props.iconColor : "",
                  }}
                />
              )}

              <Typography
                variant="h5"
                fontWeight={700}
                style={{
                  color: props.digitColor ? props.digitColor : "",
                }}
                className={props.valueStyles && props.valueStyles}
              >
                {props?.value}
              </Typography>

              {_.isNumber(props.percentageValue) && (
                <Typography variant="h6" fontWeight={500}>
                  ({props?.percentageValue}%)
                </Typography>
              )}
            </>
          )}
        </div>
      </div>
    );
}

ExtendedComponentWidget.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onRootClick:  PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
    percentageValue: PropTypes.number,
    iconName: PropTypes.string,
    iconColor: PropTypes.string,
    digitColor: PropTypes.string,
    borderColor: PropTypes.string,
    secondaryTitle: PropTypes.node,
    noIcon: PropTypes.bool,
    renderContent: PropTypes.func,
    noGap: PropTypes.bool,
    titleStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    contentStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ExtendedComponentWidget.defaultProps = {
    noIcon: false,
    noGap: false,
    titleStyle: null,
    contentStyle: null,
    secondaryTitle: null,
};

export default ExtendedComponentWidget;